import React, { createContext, useReducer } from "react"
import { initialState } from "./ContextState"
import { DispatchNexus } from "./DispatchNexus"
import { InitialStateType, mainReducer } from "./reducers/Reducer"

const RootContext = createContext<{
    state: InitialStateType
    dispatch: DispatchNexus
}>({
    state: initialState,
    dispatch: () => null,
})

interface Props {
    children?: React.ReactNode
}

const RootProvider: React.FC<Props> = ({ children }) => {
    const [state, dispatch] = useReducer(mainReducer, initialState)

    return <RootContext.Provider value={{ state, dispatch }}>{children}</RootContext.Provider>
}

export { RootProvider, RootContext }
